import React from "react";
import firebase from "../../Config/fbConfig"
import { Steps, Input, Form, Button, Row,Col } from 'antd';
import { connect } from 'react-redux';
import { UserOutlined } from '@ant-design/icons';
import {signInWithPhoneNumber, verifyCode} from "../../Store/Actions/auth";
import Navbar from "../Layout/Navbar";
const { Step } = Steps;

const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

const FirstStep = ({ signInWithPhoneNumber, onChange }) => {

    return (
        <div>
            <Row gutter={8}>
                <Col span={12}>
                    <div>
                        <div className="uk-form-width-large">
                            <Form
                                {...layout}
                                name="basic"
                            >
                                <h4 className="uk-h2 uk-text-bold">
                                    Login with phone number
                                </h4>
                                <Form.Item
                                    label={
                                        <h3 className="uk-h4 uk-margin-remove">
                                            Phone number
                                        </h3>
                                    }
                                    rules={[{ required: true, message: 'Please input your username!' }]}
                                >
                                    <Input placeholder="Phone number" id="phone" onChange={onChange} size="large" prefix={<UserOutlined />} />
                                </Form.Item>

                                <Form.Item>
                                    <Button size="large" onClick={signInWithPhoneNumber} type="primary">
                                        Submit
                                    </Button>
                                </Form.Item>

                            </Form>
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div>
                        <div className="uk-padding">
                            <img className="uk-width-1-1" src={require("../Media/images/undraw_business_shop_qw5t.svg")} />
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
};
const SecondStep = ({ changeCurrent, verifyCode, onChange }) => {

    return (
        <div>
            <Row gutter={8}>
                <Col span={12}>
                    <div>
                        <div className="uk-form-width-large">
                            <Form
                                {...layout}
                                name="basic"
                            >
                                <h4 className="uk-h2 uk-text-bold">
                                    Enter confirmation code
                                </h4>
                                <Form.Item
                                    label={
                                        <h3 className="uk-h4 uk-margin-remove">
                                            Phone number
                                        </h3>
                                    }
                                    rules={[{ required: true, message: 'Please input your username!' }]}
                                >
                                    <Input disabled placeholder="Phone number" id="phone" onChange={onChange} size="large" prefix={<UserOutlined />} />
                                </Form.Item>

                                <Form.Item
                                    label="Code number"
                                    rules={[{ required: true, message: 'Please input your username!' }]}
                                >
                                    <Input id="code" onChange={onChange} size="large" prefix={<UserOutlined />} />
                                </Form.Item>


                                <Form.Item>
                                    <Row>
                                        <Col>
                                            <Button size="large" onClick={() => changeCurrent(0)} type="primary">
                                                Back
                                            </Button>
                                        </Col>
                                        <Col>
                                            <Button size="large" onClick={verifyCode} type="primary">
                                                Submit
                                            </Button>
                                        </Col>
                                    </Row>
                                </Form.Item>

                            </Form>
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div>
                        <div className="uk-padding">
                            <img className="uk-width-1-1" src={require("../Media/images/undraw_business_shop_qw5t.svg")} />
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
};
const ThirdStep = ({ user }) => {
    return (
        <div>
            { user ? user.displayName : "User not found" }
            { user ? user.phoneNumber : "User not found" }
        </div>
    )
};





class Auth extends React.Component {

    state = {
        current: 0,
        confirmationResult: null,
        phone: "",
        code: ""
    }


    onChange = e => {
        console.log(e.target.id, e.target.value);
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    componentDidMount() {
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container",
        {
            size:"invisible",
            "callback": function(response) {
                signInWithPhoneNumber();
            }
        });
    }

    signInWithPhoneNumber = () => {
        const appVerifier = window.recaptchaVerifier;
        const phoneNumber = this.state.phone;
        signInWithPhoneNumber({ phoneNumber, appVerifier }, (res) => {
            this.setState({
                confirmationResult: res,
                current: res ? 1 : 0
            })
        });
    };

    verifyCode = () => {
        const { confirmationResult, code } = this.state;
        if (confirmationResult) {
            verifyCode({ confirmationResult, code}, (res) => {
                this.setState({
                    current: res ? 2 : 1
                })
            })
        }
    }

    changeCurrent = current => {
        this.setState({
            current: current
        })
    }

    render() {
        const { auth } = this.props;
        const { current } = this.state;

        const steps = [
            <FirstStep onChange={this.onChange} signInWithPhoneNumber={this.signInWithPhoneNumber} />,
            <SecondStep changeCurrent={this.changeCurrent} onChange={this.onChange} verifyCode={this.verifyCode} />,
            <ThirdStep user={auth} />
        ]

        return (
            <div className="uk-background-muted" style={{ height: "calc(100vh)"}}>
                <Navbar current="auth" />

                <div className="uk-margin-large-top">
                    <div className="uk-container uk-background-default uk-padding">
                        <div>
                            <Steps current={current}>
                                <Step title="Enter phone number" description="This is a description." />
                                <Step title="Confirm phone number" description="This is a description." />
                                <Step title="Welcome to the Qolzhetimdi" description="This is a description." />
                            </Steps>
                        </div>

                        <div id="recaptcha-container"></div>
                        <div className="uk-margin">
                            { steps[current] }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    return {
        auth: state.firebase.auth
    }
}

export default connect(mapStateToProps)(Auth);



// WEBPACK FOOTER //
// ./src/Components/Auth/index.js